
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.45 10.757c-2.112 0-2.975-1.494-1.925-3.325a2.213 2.213 0 00-.817-3.022L18.69 3.255c-.922-.548-2.112-.222-2.66.7l-.128.222c-1.05 1.831-2.777 1.831-3.839 0l-.128-.222a1.915 1.915 0 00-2.637-.7L7.28 4.41a2.226 2.226 0 00-.817 3.033c1.062 1.82.199 3.314-1.913 3.314a2.223 2.223 0 00-2.217 2.216v2.053c0 1.214.992 2.217 2.217 2.217 2.112 0 2.975 1.494 1.913 3.325a2.213 2.213 0 00.817 3.022l2.018 1.155c.922.548 2.112.221 2.66-.7l.129-.222c1.05-1.832 2.776-1.832 3.838 0l.128.222c.549.921 1.739 1.248 2.66.7l2.019-1.155a2.216 2.216 0 00.816-3.022c-1.061-1.832-.198-3.325 1.914-3.325a2.223 2.223 0 002.216-2.216v-2.054a2.24 2.24 0 00-2.228-2.216zM14 17.79A3.8 3.8 0 0110.208 14 3.799 3.799 0 0114 10.208 3.799 3.799 0 0117.792 14 3.8 3.8 0 0114 17.79z","fill":"#292D32"}})])
          )
        }
      }
    